import { useContext, useEffect, useState } from 'react';
import { ConfigContext } from 'contexts/ConfigContext';
import axios from 'utils/axios';

// ==============================|| CONFIG - HOOKS  ||============================== //

const useConfig = () => useContext(ConfigContext);

export default useConfig;

export const useThemeColors = () => {
    const [colors, setColors] = useState(null);
    useEffect(() => {
        axios({
            url: `/theme/init`,
            method: 'get',
        }).then((data: any) => {
            setColors(data?.colors || null);
        });
    }, []);
    return colors;
};
